import {
  LOGIN_REQUIEST,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  CLEAR_ERROR,

  REGISTER_USER_REQUIEST,
  REGISTER_USER_SUCCESS,
  REGISTER_USER_FAIL,

  LOAD_USER_SUCCESS,
  LOAD_USER_FAIL,

  LOG_OUT_SUCCESS,
  LOG_OUT_FAIL,

  USER_ROLE_REQUIEST,
  USER_ROLE_SUCCESS,
  USER_ROLE_FAIL,

  UPDATE_PROFILE_REQUIEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,

  UPDATE_PASSWORD_REQUIEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAIL,

  FORGOT_PASSWORD_REQUIEST,
  FORGOT_PASSWORD_SUCCESS,
  RESET_PASSWORD_REQUIEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,

  GET_ALL_USER_REQUIEST,
  GET_ALL_USER_SUCCESS,
  GET_ALL_USER_FAIL,

  DELETE_USER_ROLE_REQUIEST,
  DELETE_USER_ROLE_SUCCESS,
  DELETE_USER_ROLE_FAIL,

  GET_WISHLIST_REQUEST,
  GET_WISHLIST_PRODUCT,
  GET_WISHLIST_FAIL,

  GET_USER_BY_ID_REQUEST,
  GET_USER_BY_ID_SUCCESS,
  GET_USER_BY_ID_FAIL,

  STORE_LOGIN_REQUEST,
  STORE_LOGIN_SUCCESS,
  STORE_LOGIN_FAIL
} from "../constants/userConstant";

import API from "../api";

/* ========================= LOGIN ========================= */
export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_REQUIEST });

    const { data } = await API.post(
      "/login",
      { email, password },
      { withCredentials: true }
    );

    localStorage.setItem("token", data?.token);

    dispatch({
      type: LOGIN_SUCCESS,
      payload: data?.user,
    });
  } catch (error) {
    dispatch({
      type: LOGIN_FAIL,
      payload: error?.response?.data?.message || "Login failed",
    });
  }
};

/* ========================= REGISTER ========================= */
export const register = (userData) => async (dispatch) => {
  try {
    dispatch({ type: REGISTER_USER_REQUIEST });

    const { data } = await API.post("/register", userData, {
      withCredentials: true,
      headers: { "Content-Type": "multipart/form-data" },
    });

    localStorage.setItem("token", data?.token);

    dispatch({
      type: REGISTER_USER_SUCCESS,
      payload: data?.user,
    });
  } catch (error) {
    dispatch({
      type: REGISTER_USER_FAIL,
      payload: error?.response?.data?.message || "Registration failed",
    });
  }
};

/* ========================= LOAD USER ========================= */
export const loadUser = () => async (dispatch) => {
  try {
    const { data } = await API.get("/me", { withCredentials: true });

    dispatch({
      type: LOAD_USER_SUCCESS,
      payload: data?.user,
    });
  } catch (error) {
    dispatch({
      type: LOAD_USER_FAIL,
      payload: error?.response?.data?.message || "User not logged in",
    });
  }
};

/* ========================= LOGOUT ========================= */
export const logout = () => async (dispatch) => {
  try {
    await API.get("/logout", { withCredentials: true });

    localStorage.removeItem("token");

    dispatch({ type: LOG_OUT_SUCCESS });
  } catch (error) {
    dispatch({
      type: LOG_OUT_FAIL,
      payload: error?.response?.data?.message || "Logout failed",
    });
  }
};

/* ========================= GET USER BY ID ========================= */
export const getUserById = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_USER_BY_ID_REQUEST });

    const { data } = await API.get(`/user/${id}`);

    dispatch({
      type: GET_USER_BY_ID_SUCCESS,
      payload: data?.user,
    });
  } catch (error) {
    dispatch({
      type: GET_USER_BY_ID_FAIL,
      payload: error?.response?.data?.message || "User not found",
    });
  }
};

/* ========================= ADMIN: GET ALL USERS ========================= */
export const getAllUsers = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_USER_REQUIEST });

    const { data } = await API.get("/admin/users");

    dispatch({
      type: GET_ALL_USER_SUCCESS,
      payload: data?.users,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_USER_FAIL,
      payload: error?.response?.data?.message || "Failed to fetch users",
    });
  }
};

/* ========================= UPDATE PROFILE ========================= */
export const profileUpdate = (userData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PROFILE_REQUIEST });

    const { data } = await API.put("/me/update", userData, {
      withCredentials: true,
    });

    dispatch({
      type: UPDATE_PROFILE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_PROFILE_FAIL,
      payload: error?.response?.data?.message || "Profile update failed",
    });
  }
};

/* ========================= UPDATE PASSWORD ========================= */
export const updatePassword = (password) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PASSWORD_REQUIEST });

    const { data } = await API.put("/password/update", password, {
      withCredentials: true,
    });

    dispatch({
      type: UPDATE_PASSWORD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_PASSWORD_FAIL,
      payload: error?.response?.data?.message || "Password update failed",
    });
  }
};

/* ========================= FORGOT PASSWORD ========================= */
export const forgotPassword = (email) => async (dispatch) => {
  try {
    dispatch({ type: FORGOT_PASSWORD_REQUIEST });

    const { data } = await API.post("/password/forgot", email);

    dispatch({
      type: FORGOT_PASSWORD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_PASSWORD_FAIL,
      payload: error?.response?.data?.message || "Email not sent",
    });
  }
};

/* ========================= RESET PASSWORD ========================= */
export const resetPassword = (token, password) => async (dispatch) => {
  try {
    dispatch({ type: RESET_PASSWORD_REQUIEST });

    const { data } = await API.put(`/password/reset/${token}`, password);

    dispatch({
      type: RESET_PASSWORD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: RESET_PASSWORD_FAIL,
      payload: error?.response?.data?.message || "Reset password failed",
    });
  }
};

/* ========================= ADMIN: UPDATE USER ROLE ========================= */
export const userRoleUpdate = (id, userData) => async (dispatch) => {
  try {
    dispatch({ type: USER_ROLE_REQUIEST });

    const { data } = await API.put(`/admin/user/${id}`, userData);

    dispatch({
      type: USER_ROLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: USER_ROLE_FAIL,
      payload: error?.response?.data?.message || "Role update failed",
    });
  }
};

/* ========================= ADMIN: DELETE USER ========================= */
export const deleteRoleUser = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_USER_ROLE_REQUIEST });

    const { data } = await API.delete(`/admin/user/${id}`);

    dispatch({
      type: DELETE_USER_ROLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: DELETE_USER_ROLE_FAIL,
      payload: error?.response?.data?.message || "Delete failed",
    });
  }
};

/* ========================= WISHLIST ========================= */
export const getAllWishlist = () => async (dispatch) => {
  try {
    dispatch({ type: GET_WISHLIST_REQUEST });

    const { data } = await API.get("/wishlist");

    dispatch({
      type: GET_WISHLIST_PRODUCT,
      payload: data?.finduser?.wishlist || [],
    });
  } catch (error) {
    dispatch({
      type: GET_WISHLIST_FAIL,
      payload: error?.response?.data?.message || "Wishlist fetch failed",
    });
  }
};

/* ========================= STORE LOGIN ========================= */
export const storeLogin = (username, password) => async (dispatch) => {
  try {
    dispatch({ type: STORE_LOGIN_REQUEST });

    const { data } = await API.post("/store/login", {
      username: username.toLowerCase(),
      password,
    });

    localStorage.setItem("storeAuth", JSON.stringify(data.store));

    dispatch({
      type: STORE_LOGIN_SUCCESS,
      payload: data.store,
    });
  } catch (error) {
    dispatch({
      type: STORE_LOGIN_FAIL,
      payload: error?.response?.data?.message || "Store login failed",
    });
  }
};

/* ========================= CLEAR ERRORS ========================= */
export const clearErrors = () => (dispatch) => {
  dispatch({ type: CLEAR_ERROR });
};
